import { Box } from "@mantine/core";

const CurrentPlanComponent = () => {
  return <Box className="current-plan">Current plan</Box>;
};
export default CurrentPlanComponent;
